/**
 * Predefined constant values used by the Québec vaccination registry.
 */
class ConstantValues {
    /**
     * The ConditionModel.Reason code for a proof of immunity.
     */
    public static readonly ConditionReason_ProofOfImmunity = "PREIMM";

    /**
    * The immunization statuses which indicate it's invalid.
     */
    public static readonly InvalidStatuses = ["OI", "FI", "DI"];

    /**
     * The code used for "Autre" reason found in immunization profile sub components.
     */
    public static readonly OtherReasonCode = "OTH";

    /**
     * The code used for "Inconnu" dose unit found in immunization form.
     */
    public static readonly UnknownDoseUnitCode = "I";

    /**
     * The code used for an "Inconnu" site found in immunization form.
     */
    public static readonly UnknownSiteCode = "I";

    /**
     * The code used for an "Inconnu" route found in immunization form.
     */
    public static readonly UnknownRouteCode = "UNKN";

    /**
     * The ID of the unknown practitioner in the RVQ domain values.
     */
    public static readonly PractitionerUnknownId = 20497;

    /**
     * The ID of the uknown location in the RVQ domain values.
     */
    public static readonly LocationUnknownId = 6906;

    /**
     * The code for "Refus de l'usager" for a vaccination refusal reason.
     */
    public static readonly PatientRefusalReasonCode: string = "RDLU";

    /**
     * The code for "Refus du représentant légal" for a vaccination refusal reason.
     */
    public static readonly LegalRepresentativeRefusal: string = "RPL";

    /**
     * The code for "Tous les vaccins" for a vaccination refusal.
     */
    public static readonly AllVaccinations: string = "inspq_all";

    /**
     * Mapping between the MYLE pre-RVQ site code and RVQ equivalent.
     */
    public static readonly SitesToQuebecVaccinationRegistryConversionCode = {
        "VastusLateralisG": "RATH",
        "VastusLateralisL": "LATH",
        "VentroglutealG": "RVG",
        "VentroglutealL": "LVG",
        "LeftArm": "LLFA",
        "RightArm": "RLFA"
    };

    /**
     * Mapping between the MYLE pre-RVQ route code and RVQ equivalent.
     */
    public static readonly RoutesQuebecVaccinationRegistryConversionCode = {
        "IDINJ": "ID",
        "IM": "IM",
        "NASAL": "INTRAN",
        "NASALINSTIL": "INTRAN",
        "NASINHL": "INTRAN",
        "PO": "PO",
        "SQ": "SC"
    };

    /**
     * Mapping between the MYLE pre-RVQ dose unit code and RVQ equivalent.
     */
    public static readonly DoseUnitsQuebecVaccinationRegistryConversionCode = {
        "DU.mL": "INV.UnitOfMeasure2"
    };
}

export { ConstantValues };
